import {Observable} from './observable.js';


class EscapeObserverClass {
  handleKeydown = (event) => {
    if (event.keyCode === 27) {
      this._observer.notify();
    }
  };

  constructor() {
    this._observer = new Observable();
  }

  initialize() {
    document.addEventListener('keydown', this.handleKeydown);
  }

  onEscape(callback) {
    this._observer.subscribe(callback);
  }
}

export const EscapeObserver = new EscapeObserverClass();
